import { render, staticRenderFns } from "./MoveCompany.vue?vue&type=template&id=27092d76"
import script from "./MoveCompany.vue?vue&type=script&lang=js"
export * from "./MoveCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports